export default "PACKAGE_DESKTOP";
